import * as S from 'pages/Institutional/style'

const Privacy = () => {
  return (
    <S.Page>
      <S.Container>
        <S.Hero>
          <S.Eyebrow>Políticas RedSterna</S.Eyebrow>
          <S.Title>Política de Privacidade</S.Title>
          <S.Lead>
            Esta política explica, de forma clara, quais dados podem ser
            tratados pela RedSterna, para que eles são usados e quais escolhas e
            direitos você possui ao utilizar a plataforma.
          </S.Lead>
          <S.UpdatedAt>Última atualização: 18/09/2026</S.UpdatedAt>
        </S.Hero>

        <S.Body>
          <S.Section>
            <S.SectionTitle>1. Sobre esta política</S.SectionTitle>
            <S.Paragraph>
              A RedSterna é uma plataforma digital voltada à descoberta,
              planejamento e compartilhamento de experiências de viagem. Ao
              utilizar nossos serviços, algumas informações podem ser tratadas
              para viabilizar sua conta, exibir conteúdos, melhorar a navegação,
              proteger a comunidade e operar funcionalidades da plataforma.
            </S.Paragraph>
            <S.Paragraph>
              O tratamento de dados busca observar a legislação brasileira
              aplicável, incluindo a Lei Geral de Proteção de Dados Pessoais
              (LGPD).
            </S.Paragraph>
          </S.Section>

          <S.Section>
            <S.SectionTitle>2. Quais dados podemos tratar</S.SectionTitle>
            <S.List>
              <li>
                <strong>Dados de cadastro:</strong> como nome, sobrenome,
                e-mail, país, data de nascimento e demais informações
                preenchidas no perfil.
              </li>
              <li>
                <strong>Conteúdo publicado:</strong> roteiros, cidades,
                descrições, imagens, avaliações, favoritos e outras interações
                realizadas dentro da plataforma.
              </li>
              <li>
                <strong>Dados técnicos:</strong> como endereço IP, navegador,
                sistema operacional, identificadores de sessão, registros de
                acesso e informações necessárias à segurança e estabilidade do
                serviço.
              </li>
              <li>
                <strong>Localização:</strong> quando você autorizar esse recurso
                no dispositivo ou navegador. O uso da localização não é
                obrigatório para acessar a plataforma.
              </li>
              <li>
                <strong>Cookies e tecnologias semelhantes:</strong> quando
                utilizados para autenticação, preferências, desempenho,
                segurança ou métricas de uso.
              </li>
            </S.List>
          </S.Section>

          <S.Section>
            <S.SectionTitle>
              3. Para que usamos essas informações
            </S.SectionTitle>
            <S.List>
              <li>criar, autenticar e manter sua conta;</li>
              <li>permitir a criação e exibição de roteiros e perfis;</li>
              <li>personalizar a experiência de navegação;</li>
              <li>viabilizar avaliações, favoritos, conexões e interações;</li>
              <li>prevenir fraudes, abusos e usos indevidos;</li>
              <li>corrigir falhas e melhorar desempenho e funcionalidades;</li>
              <li>
                cumprir obrigações legais ou responder a autoridades
                competentes;
              </li>
              <li>
                enviar comunicações essenciais relacionadas à sua conta e à
                plataforma.
              </li>
            </S.List>
          </S.Section>

          <S.Section>
            <S.SectionTitle>4. Idade mínima</S.SectionTitle>
            <S.Paragraph>
              A criação de conta na RedSterna é destinada a pessoas com 18 anos
              ou mais. A data de nascimento é utilizada, entre outras
              finalidades, para verificar esse requisito de acesso.
            </S.Paragraph>
          </S.Section>

          <S.Section>
            <S.SectionTitle>
              5. Conteúdo público e informações de perfil
            </S.SectionTitle>
            <S.Paragraph>
              A RedSterna possui características de rede social. Por isso,
              informações que você optar por publicar em áreas públicas —
              incluindo roteiros, imagens, descrições e dados visíveis do perfil
              — podem ser acessadas por outros usuários e, em determinados
              casos, por visitantes não autenticados.
            </S.Paragraph>
            <S.Highlight>
              Evite publicar dados pessoais sensíveis, documentos, informações
              financeiras, senhas ou qualquer conteúdo que você não queira
              tornar público.
            </S.Highlight>
          </S.Section>

          <S.Section>
            <S.SectionTitle>6. Serviços e links de terceiros</S.SectionTitle>
            <S.Paragraph>
              A plataforma pode apresentar links para serviços externos, como
              hospedagem, transporte, passeios, seguros, conectividade ou outros
              produtos relacionados a viagens. Ao acessar um serviço de
              terceiro, o tratamento de dados passa a seguir também os termos e
              políticas desse fornecedor.
            </S.Paragraph>
            <S.Paragraph>
              A RedSterna não controla as práticas de privacidade de sites,
              aplicativos ou serviços de terceiros.
            </S.Paragraph>
          </S.Section>

          <S.Section>
            <S.SectionTitle>7. Compartilhamento de dados</S.SectionTitle>
            <S.Paragraph>
              A RedSterna não vende dados pessoais. Informações podem ser
              compartilhadas quando necessário com fornecedores que apoiem a
              operação técnica da plataforma, sempre de acordo com a finalidade
              do serviço, ou quando houver obrigação legal, determinação
              judicial ou necessidade de proteção de direitos.
            </S.Paragraph>
          </S.Section>

          <S.Section>
            <S.SectionTitle>8. Retenção e exclusão</S.SectionTitle>
            <S.Paragraph>
              Os dados são mantidos pelo período necessário para prestação dos
              serviços e cumprimento das finalidades descritas nesta política.
              Quando o usuário exclui a conta, os principais dados
              identificadores do perfil são anonimizados e a conta deixa de
              ficar disponível ao público. Alguns registros técnicos podem ser
              preservados quando necessários para obrigações legais, segurança
              ou exercício de direitos.
            </S.Paragraph>
          </S.Section>

          <S.Section>
            <S.SectionTitle>9. Seus direitos</S.SectionTitle>
            <S.Paragraph>
              Nos termos da legislação aplicável, você pode solicitar
              informações sobre o tratamento dos seus dados e, quando cabível,
              requerer acesso, correção, atualização, exclusão, anonimização ou
              outras providências previstas em lei.
            </S.Paragraph>
            <S.Paragraph>
              Para solicitar atendimento relacionado à privacidade, entre em
              contato pelo e-mail{' '}
              <a href="mailto:contato@redsterna.com.br">
                contato@redsterna.com.br
              </a>
              .
            </S.Paragraph>
          </S.Section>

          <S.Section>
            <S.SectionTitle>10. Segurança</S.SectionTitle>
            <S.Paragraph>
              Adotamos medidas razoáveis para proteger informações contra acesso
              não autorizado, alteração, divulgação ou destruição indevida.
              Nenhum serviço conectado à internet, porém, pode garantir
              segurança absoluta.
            </S.Paragraph>
          </S.Section>

          <S.Section>
            <S.SectionTitle>11. Atualizações desta política</S.SectionTitle>
            <S.Paragraph>
              Esta política pode ser atualizada para refletir mudanças na
              plataforma, em processos internos ou na legislação. A versão mais
              recente permanecerá disponível nesta página, com a respectiva data
              de atualização.
            </S.Paragraph>
          </S.Section>
        </S.Body>
      </S.Container>
    </S.Page>
  )
}

export default Privacy
